import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { BaseColumnComponent } from '../../base-widget';
import { ColorCodeInterface, ColorTip } from'@ar2/common';
/**
 * カラーコードカラム
 *【カラーコード:code:string】
 *【内容:description:string】
 *【色:hex:string】
 *【ボーダー色:borderColor:string】
 *【フォント色:isTextLight:boolean】
 *【表示内容:content:string】
 *【選択候補:candidates:{label:string,value:string}[]】
 *【ハイライト:highlight:string】
 *【グループ化項目:groupItems:string[]】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-color-code-column',
  templateUrl: './color-code-column.html',
  styles: [`
    .mat-icon-button {
      line-height: 20px;
      height: 20px;
      width: 20px;
    }
  `]
})
export class ColorCodeColumn extends BaseColumnComponent {
  /**
   * 項目添字
   */
  @Input() index:number

  /**
   * リスト内容
   */
  @Input() records:any[]

  /**
   * カラーコードの表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * カラーコードに対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * カラーコード
   */
  @Input() code:string

  /**
   * 内容
   */
  @Input() description:string

  /**
   * 色
   */
  @Input() hex:string

  /**
   * ボーダー色
   */
  @Input() borderColor:string

  /**
   * フォント色
   */
  @Input() isTextLight:boolean

  /**
   * 表示内容
   */
  @Input() content:string

  /**
   * 選択候補
   */
  @Input() candidates:{label:string,value:string}[]

  /**
   * ハイライト
   */
  @Input() highlight:string

  /**
   * グループ化項目
   */
  @Input() groupItems:string[]

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get htmlId():string {
    return `${this.id}[${this.index}]`
  }
  get selectedItem():{label:string,value:string} {
    return (this.candidates || []).find(
      each => each.value === this.content
    ) || {label:'', value:''}
  }
  getHighlight() {
    if (this.highlight === 'attention') {
      return 'highlight-attention'
    } else if (this.highlight === 'positive') {
      return 'highlight-positive'
    } else if (this.highlight === 'negative') {
      return 'highlight-negative'
    }
    return
  }
  
  public getColorCode() {
    let color = {} as  ColorCodeInterface;
    if (this.hex) {
      color = {
        hex: this.hex,
        code: this.code,
        description:this.description ,
        borderColor: this.borderColor,
        isTextLight: this.isTextLight
      };
      return color;
    } else {
      return color;
    }
  }
    
  public getColorTip() {
    const color:ColorTip = {
      code: this.code,
      name: this.description
    };
    return color;
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/color-code-column/color-code-column.component.ts